import cx from 'classnames'
import Link from 'next/link'
import type { Component, ReactNode } from 'react'

import { useAppSelector } from 'src/store/hooks'
import { getActiveCurrencyIdSelector } from 'store/modules/currencies/selectors'

import classes from './styles.module.scss'

type Props = {
  children?: ReactNode
  text?: string
  icon?: unknown
  onClick?: () => void
  key?: number | string
  isActive?: boolean
  href?: string
  dataTestId?: string
}

export default function MenuItemComponent(props: Props) {
  const activeCurrency = useAppSelector(getActiveCurrencyIdSelector)

  const Icon = props.icon as typeof Component
  const selectedClass = classes[activeCurrency]

  if (props?.href?.includes('https')) {
    return (
      <a
        data-testid={props?.dataTestId || 'menu-base-item'}
        onClick={props.onClick}
        className={cx(classes.link, props.isActive && selectedClass)}
        href={props.href}
        target='_blank'
        rel='noreferrer'
      >
        {Icon && <Icon className={cx(classes.icon, props.isActive && selectedClass)} />}
        {props.text}
      </a>
    )
  }
  if (props?.href) {
    return (
      <Link
        href={props.href}
        prefetch={false}
        passHref
        data-testid={props?.dataTestId || 'menu-base-link'}
        onClick={props.onClick}
        className={cx(classes.link, props.isActive && selectedClass)}
      >
        {Icon && <Icon className={cx(props.isActive && selectedClass)} />}
        {props.text}
      </Link>
    )
  }

  return (
    <div
      data-testid={props?.dataTestId || 'menu-base-button'}
      onClick={props.onClick}
      className={cx(classes.linkText, classes.link, props.isActive && selectedClass)}
    >
      {Icon && <Icon className={cx(props.isActive && selectedClass)} />}
      {props.text}
    </div>
  )
}
